import { createSelector } from '@ngrx/store';
import { addressProviderState } from '../root';

export const getAddressProviderSearchResults = (searchTerm: string) =>
    createSelector(addressProviderState, (addressProvider) => addressProvider?.places?.find((place) => place.search === searchTerm)?.data || null);
